// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"24ae7036","52":"24459a21","53":"66fab525","513":"1dc5e28c","554":"96837988","588":"101b9741","612":"3292f602","655":"64a13b76","755":"11345fe4","787":"65825ecf","978":"e7a4864a"}[chunkId] + ".chunk.js";
};